/*
 *
 * PayByLinkFirstActivationPopup
 *
 * @version 1.0.0
 * @author a.mancuso
 * @since 27-Mar-2025
*/

import PayByLinkFirstActivationPopup from './PayByLinkFirstActivationPopupContainer'

export default PayByLinkFirstActivationPopup
